/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import axios from '../../../server';
import { CreateFormResponse } from './types';

const { model, array, string } = types;

export const AdminFormStore = model('AdminFormStore', {
  roles: array(string),
})
  .views((self) => ({}))
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeRoles({ data }: AxiosResponse): string[] {
      self.roles.replace(data.data.permissions);
      return self.roles;
    },
  }))
  .actions((self) => ({
    getRoles: flow(function* () {
      const result = yield axios
        .get<CreateFormResponse>('admin/admins/create')
        .then(self.normalizeRoles)
        .catch((error) => {
          throw new Error(error.response.data.message);
        });
      return result;
    }),
  }));

export type IAdminFormStore = Instance<typeof AdminFormStore>;
